import { preChat } from './preChat';

const esCr = {
  ...preChat,
};

export default esCr;
